import first from 'lodash/first';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Box, Flex, Heading, Link, Icon, Text } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import errorDefinitions from './errorDefinitions';

const StyledLink = styled(Link)`
  font-size: ${themeGet('fontSizes.sm')};
  text-decoration: underline;
`;

const getError = ({ errors, type }) => {
  const { agentResolvable, code } = first(errors) || {};
  const { heading, description } = errorDefinitions[code] || {};

  return {
    agentResolvable,
    code,
    heading: heading || 'We had a problem processing your payment.',
    description: description || `Please check your ${type} details and try again.`,
  };
};

const BookingError = ({ errors, type }) => {
  if (!errors.length) return null;

  const { agentResolvable, description, heading } = getError({ errors, type });

  return (
    <Flex backgroundColor="ui.errorBackground" flexDirection="column" mb={4} p={6}>
      <Flex alignItems="center" mb={2}>
        <Icon data-testid="error-icon" display="inline" mr={2} name="warning" color="ui.error" />
        <Heading data-testid="error-heading" display="inline" fontSize={18} mb={0}>
          {heading}
        </Heading>
      </Flex>
      <Box>
        <Text display="inline" data-testid="error-description" color="greys.steel">
          {description}
        </Text>
        {agentResolvable && (
          <Fragment>
            <Text display="inline" color="greys.steel">
              {`   `}For further assistance, please
            </Text>
            &nbsp;
            <StyledLink color="greys.steel" data-testid="contact-link" href="/hotels/contact-us" target="_blank">
              contact us.
            </StyledLink>
          </Fragment>
        )}
      </Box>
    </Flex>
  );
};

BookingError.propTypes = {
  errors: PropTypes.array,
  type: PropTypes.string,
};

BookingError.defaultProps = {
  errors: [],
  type: 'payment',
};

export default BookingError;
